import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { MarkdownRendererProps } from './MarkdownRenderer.types';
import { MarkdownAnchorRenderer } from '../MarkdownAnchorRenderer';
import { MarkdownRendererContextProvider } from '../MarkdownRendererContextProvider';
import {
  MarkdownEmRenderer,
  MarkdownLiRenderer,
  MarkdownParagraphRenderer,
  MarkdownSpanRenderer,
  MarkdownStrongRenderer,
} from '../MarkdownComponentsWithHighlights';

const MarkdownRendererBase: React.FC<MarkdownRendererProps> = ({
  content,
  components,
  highlights,
  matchWholeWords,
  className,
}) => {
  return (
    <MarkdownRendererContextProvider highlights={highlights} matchWholeWords={matchWholeWords}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: MarkdownAnchorRenderer,
          p: MarkdownParagraphRenderer,
          strong: MarkdownStrongRenderer,
          em: MarkdownEmRenderer,
          li: MarkdownLiRenderer,
          span: MarkdownSpanRenderer,
          ...components,
        }}
        className={className}
      >
        {content}
      </ReactMarkdown>
    </MarkdownRendererContextProvider>
  );
};

export const MarkdownRenderer = memo(MarkdownRendererBase);
